export default __webpack_public_path__ + "static/media/vs-vip-icon.ae7b07aa.svg";